<template>
  <div class="admin-import-container">
    <div class="header-toolbar">
      <h2>订单导入</h2>
      <el-button type="info" @click="goBack">返回订单列表</el-button>
    </div>

    <!-- 导入说明 -->
    <div class="import-tip">
      <h4>导入规则：</h4>
      <ul>
        <li>
          1.
          仅支持Excel文件（.xlsx/.xls格式），表头需包含【客户编号、PO号、产品型号、订单数量】（必填）
        </li>
        <li>
          2. 唯一键：客户编号+PO号+产品型号+订单数量，重复时自动覆盖原有数据
        </li>
        <li>3. 进度自动计算：进度=已完成数量/订单数量（保留2位小数）</li>
        <li>4. 更新时间自动设置为当前导入日期</li>
      </ul>
      <el-button type="text" @click="downloadTemplate">下载Excel模板</el-button>
    </div>

    <!-- 🔥 修复核心：简化el-upload属性，消除语法错误 -->
    <div class="upload-container">
      <el-upload
        class="upload-demo"
        :file-list="fileList"
        :before-upload="beforeUpload"
        auto-upload="false"
        :http-request="handleCustomUpload"
        accept=".xlsx,.xls"
        action="#"
      >
        <el-button size="large" type="primary">选择Excel文件</el-button>
        <div slot="tip" class="el-upload__tip">
          请上传.xlsx或.xls格式的Excel文件，大小不超过10MB
        </div>
      </el-upload>
      <!-- 手动上传按钮 -->
      <el-button
        type="success"
        @click="handleManualUpload"
        style="margin-top: 15px"
        :disabled="fileList.length === 0"
      >
        开始上传
      </el-button>
    </div>

    <!-- 导入结果弹窗 -->
    <el-dialog title="导入结果" :visible.sync="resultDialogVisible" width="50%">
      <div class="result-content">
        <div v-if="importResult.code === 200">
          <i class="el-icon el-icon-success success-icon"></i>
          <h3>导入成功！</h3>
          <!-- <p>成功条数：{{ importResult.successCount }}</p>
          <p>失败条数：{{ importResult.failCount }}</p> -->
          <p>{{ importResult.msg }}</p>
          <div v-if="importResult.failCount > 0">
            <h4>失败原因：</h4>
            <ul class="fail-list">
              <li
                v-for="(reason, index) in importResult.failReasons"
                :key="index"
              >
                {{ reason }}
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <i class="el-icon el-icon-error error-icon"></i>
          <h3>导入失败！</h3>
          <p>{{ importResult.msg || "未知错误" }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resultDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Message } from "element-ui";

export default {
  name: "AdminOrderImport",
  data() {
    return {
      fileList: [],
      resultDialogVisible: false,
      importResult: {},
      selectedFile: null,
    };
  },
  methods: {
    goBack() {
      this.$router.push("/admin-order-list");
    },
    downloadTemplate() {
      const url = "/api/order/template";
      window.open(url, "_blank");
    },
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 10) {
        Message.error("文件大小不能超过10MB");
        return false;
      }
      // 覆盖fileList，只保留当前文件（实现“覆盖上一次选择”）
      this.fileList = [file];
      this.selectedFile = file;
      return true;
    },
    handleCustomUpload() {},
    handleManualUpload() {
      if (!this.selectedFile) {
        Message.warning("请先选择Excel文件");
        return;
      }

      const formData = new FormData();
      formData.append("file", this.selectedFile);

      request({
        url: "/api/order/import",
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 30000,
      })
        .then((res) => {
          this.resultDialogVisible = true;
          this.importResult = res;
          // 清空选择记录和UI展示
          this.fileList = [];
          this.selectedFile = null;
        })
        .catch((err) => {
          console.error("上传失败：", err);
          this.resultDialogVisible = true;
          this.importResult = {
            code: 500,
            msg: "上传失败，请检查网络或文件格式",
          };
          // 清空选择记录和UI展示
          this.fileList = [];
          this.selectedFile = null;
        });
    },
  },
};
</script>

<style scoped>
.admin-import-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.header-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.import-tip {
  background-color: #fff;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
}
.import-tip ul {
  margin: 10px 0;
  padding-left: 20px;
  color: #666;
  line-height: 1.8;
}
.upload-container {
  background-color: #fff;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
}
.result-content {
  padding: 20px;
  text-align: center;
}
.success-icon {
  color: #67c23a;
  font-size: 48px;
  margin-bottom: 15px;
  display: inline-block;
}
.error-icon {
  color: #f56c6c;
  font-size: 48px;
  margin-bottom: 15px;
  display: inline-block;
}
.fail-list {
  text-align: left;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 10px;
  margin-top: 10px;
  color: #f56c6c;
}
.fail-list li {
  margin: 5px 0;
}
</style>